import { messageDuration } from "@/config/settings";
import * as lodash from "lodash";
import { Message, MessageBox } from "element-ui";
import i18n from "@/i18n";

const install = (Vue) => {
  /* 全局Message */
  Vue.prototype.$baseMessage = (message, type) => {
    Message({
      offset: 60,
      showClose: true,
      message: message,
      type: type,
      dangerouslyUseHTMLString: true,
      duration: messageDuration,
    });
  };

  /* 全局Confirm */
  Vue.prototype.$baseConfirm = (content, title, callback1, callback2) => {
    MessageBox.confirm(content, title || i18n.t("common.tip"), {
      confirmButtonText: i18n.t("common.confirm"),
      cancelButtonText: i18n.t("common.cancel"),
      closeOnClickModal: false,
      type: "warning",
    })
      .then(() => {
        if (callback1) {
          callback1();
        }
      })
      .catch(() => {
        if (callback2) {
          callback2();
        }
      });
  };
  /* 全局Confirm */
  Vue.prototype.$baseConfirm2 = (
    content,
    title,
    okBtnTex,
    cannelBtnTex,
    callback1,
    callback2
  ) => {
    MessageBox.confirm(content, title || i18n.t("common.tip"), {
      confirmButtonText: okBtnTex || i18n.t("common.confirm"),
      cancelButtonText: cannelBtnTex || i18n.t("common.cancel"),
      closeOnClickModal: false,
      type: "warning",
    })
      .then(() => {
        if (callback1) {
          callback1();
        }
      })
      .catch(() => {
        if (callback2) {
          callback2();
        }
      });
  };

  Vue.prototype.$baseLodash = lodash;
  /* 全局事件总线 */
  Vue.prototype.$baseEventBus = new Vue();
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default install;
